import SEOLandingTemplate from './SEOLandingTemplate';

export default function KeywordDensityPage() {
  return (
    <SEOLandingTemplate
      title="Keyword Density Checker"
      metaTitle="Free Keyword Density Checker | Sungresh"
      metaDescription="Check keyword density and placement for any live page using a real crawler. See frequency, word count, and where your target keyword appears."
      h1="Free Keyword Density Checker"
      sub="Enter a live URL and a target keyword to see how often it appears, where it's placed, and whether the density is in a healthy range."
      keywords="keyword density checker, check keyword density, keyword density tool"
      ctaLink="/audit/onpage"
      ctaText="Check Density Free"
      features={[
        { icon: '📊', title: 'Density %', desc: 'Keyword occurrences as a percentage of total words' },
        { icon: '🔢', title: 'Frequency', desc: 'Raw count of keyword appearances' },
        { icon: '🎯', title: 'Placement Check', desc: 'Whether the keyword appears in the title, H1, and opening paragraph' },
        { icon: '⚠️', title: 'Stuffing Warning', desc: 'Flags density high enough to look unnatural' },
      ]}
      faqs={[
        { q: 'What is keyword density?', a: 'The percentage of words on a page that are your target keyword — for example, 10 occurrences in a 1,000-word page is roughly 1% density.' },
        { q: 'Is there an "ideal" density?', a: 'Roughly 0.5–2.5% is a commonly cited healthy range, but there\'s no strict rule Google enforces. The more important goal is that the keyword appears naturally where a reader would expect it — the title, an early paragraph, a heading — not that you hit an exact percentage.' },
        { q: 'Does keyword density still matter for ranking?', a: 'Less than it used to. Modern search engines rely heavily on semantic understanding of a page\'s topic, not exact keyword counting. Natural placement in key spots still helps; artificially repeating a phrase to hit a target percentage can hurt more than it helps.' },
      ]}
    />
  );
}
